import { render, staticRenderFns } from "./yhglDialog.vue?vue&type=template&id=5256f17e&scoped=true&"
import script from "./yhglDialog.vue?vue&type=script&lang=js&"
export * from "./yhglDialog.vue?vue&type=script&lang=js&"
import style0 from "./yhglDialog.vue?vue&type=style&index=0&id=5256f17e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5256f17e",
  null
  
)

export default component.exports